<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card class="custom-card">
          <b-row class="justify-content-between">
            <b-col
              sm="12"
              md="12"
              class="px-1 d-flex justify-content-between"
            >
              <b-form-group
                label-for="channel"
                class="w-100 mr-md-1"
              >
                <v-select
                  id="channel"
                  v-model="channelList"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="channel"
                  :reduce="text => text.value"
                  label="text"
                  placeholder="Select Channel"
                  @input="setChannel"
                />
              </b-form-group>
              <b-form-group
                label-for="buyMethod"
                class="w-100 ml-md-1"
              >
                <v-select
                  id="buyMethod"
                  v-model="methodList"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selectMethod"
                  :reduce="text => text.value"
                  label="text"
                  placeholder="Select Buy Method"
                  @input="setMethod"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card>
          <!-- <b-card-body> -->
          <b-alert
            show
            variant="success"
            class="mb-0"
          >
            <div class="alert-body">
              <feather-icon
                icon="InfoIcon"
                class="mr-50"
              />
              Average traffic performances for last 7 days
            </div>
          </b-alert>
          <data-table
            ref="auctionTable"
            :data-table="dataBiddingItem"
            :field-table="dataBiddingField"
            :table-for="tableFor"
            :data-for="dataFor"
            :list="list"
            :mutation-for="mutationFor"
            :filter-search="filterSearch"
            :button-download="buttonDownload"
          >
            <template #cell(bid_status)="data">
              <div class="text-right">

                <b-button
                  v-if="data.value === 'open'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  size="sm"
                  variant="outline-primary"
                  class="w-75 font-weight-bolder"
                  @click="bidAction(data.item)"
                >
                  Bid
                </b-button>
                <b-button
                  v-if="data.value === 'highest_bid'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  size="sm"
                  disabled
                  class="w-75 font-weight-bolder"
                >
                  Highest Bid
                </b-button>
                <b-button
                  v-if="data.value === 'closed'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  size="sm"
                  disabled
                  class="w-100 font-weight-bolder"
                >
                  Closed
                </b-button>
              </div>
            </template>
            <template #cell(sales)="data">
              <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
            </template>
            <template #cell(click)="data">
              <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
            </template>
            <template #cell(impression)="data">
              <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
            </template>
          </data-table>
          <!-- </b-card-body> -->
        </b-card>

      </b-col>
    </b-row>
    <popup-bid
      ref="bidPopup"
      :data-review="dataBid"
    />
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BAlert,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import DataTable from '@/views/component/DataTable.vue'

import PopupBid from '@/views/component/PopupBid.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    DataTable,
    vSelect,
    BAlert,
    BButton,
    PopupBid,
  },
  directives: {
    Ripple,
  },
  data() {
    const minDate = new Date()
    return {
      min: minDate,
      min2: null,
      max1: null,
      tableFor: 'auction',
      dataFor: 'dataBidding',
      mutationFor: 'BIDDING',
      disabledBtnFilter: true,
      filterSearch: false,
      buttonDownload: false,
      list: 'getDataBidding',
      totalActive: 0,
      totalRunning: 0,
      totalComplete: 0,
      totalCampaign: 0,
      isCloseable: false,
      role: this.$store.state.auth.userData.data.Account.role_id,
      dept: this.$store.state.auth.userData.data.departement.id,
      dataBid: {},
      selectMethod: [
        {
          value: 1,
          text: 'CPD',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auction', {
      dataBiddingField: 'getBiddingField',
      dataBiddingItem: 'getBiddingItem',
      dataBiddingStatus: 'getBiddingStatus',
      selectedChannel: 'getChannel',
      selectedMethod: 'getMethod',
    }),
    ...mapGetters('auth', {
      dataRole: 'getRole',
    }),
    ...mapGetters('datas', {
      channel: 'getChannel',
      methodBuy: 'getBuyMethod',
      templateID: "getDataTemplateID",
    }),
    channelList: {
      get() {
        return this.selectedChannel
      },
      set(val) {
        this.$store.state.auction.channelSelected = val
      },
    },
    methodList: {
      get() {
        return this.selectedMethod
      },
      set(val) {
        this.$store.state.auction.methodSelected = val
      },
    },
    // methodList: {
    //   get() {
    //     return this.getMethodFilter
    //   },
    //   set(val) {
    //     this.setMethodFilter(val)
    //   },
    // },
  },
  mounted() {
    this.getAdditionalData()
    this.setChannel(this.selectedChannel)
    // this.$store.state.report.dataReport.items.current_page = 1
    // })
  },
  methods: {
    ...mapActions('auction', [
      'getDataBidding',
    ]),
    ...mapActions('datas', ['getAdditionalData']),
    formatPrice(value) {
      if (!this.isFloat(value)) {
        let val = (value / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      return value
    },
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0
    },
    filterDataByDate() {
      this.getDataBidding()
    },
    toUrl(id) {
      this.$router.push({ path: `campaign/view/${id}` })
    },
    changeCompany() {
      this.getDataBidding()
    },
    showData(e) {
      // e.preventDefault()
      this.isCloseable = true
      this.handleHide(e)
      // this.$refs.dropdown.hide()
      this.getDataBidding()
    },
    // downloader(format) {
    //   this.$refs.reportTable.downloader(format)
    // },
    bidAction(items) {
      this.dataBid = items
      // console.log('items', items)
      this.$refs.bidPopup.setDataReview(items)
      this.$refs.bidPopup.showModal()
    },
    setChannel(e) {
      this.$store.state.auction.channelSelected = e
      this.getMethod(e)
    },
    getMethod(channel) {
      const listMethod = this.methodBuy.find(item => item.channel === channel)
      const checkMethod = listMethod.method.findIndex(item => item.value === this.selectedChannel)
      this.selectMethod = listMethod.method
      if (checkMethod === -1) {
        this.setMethod(listMethod.method[0].value)
      } else {
        this.setMethod(this.selectMethod[0].value)
      }
    },
    setMethod(e) {
      this.$store.state.auction.methodSelected = e
      this.getDataBidding()
    },
  },
}
</script>
<style scoped>
@media screen and (max-width: 600px){
/deep/.btn.dropdown-toggle {
    width: 100% !important;
}
}
[dir] .input-group-text {
    padding: 0.75rem 1rem;
}
[dir=ltr] .input-group-append {
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
}
.custom-card .card-body {
  padding-bottom: 0.5rem;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
